<template>
  <v-navigation-drawer app clipped fixed v-model="showMenu" class="ret-main-menu-nav-desktop">
    <v-list dense class="pa-0 ret-main-menu">
      <v-list-item
        @click="navigate({ name: 'home' })"
        data-test="navigation-home"
      >
        <v-list-item-avatar>
          <v-icon>home</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>{{ currentUser.displayName }}</v-list-item-title>
        </v-list-item-content>
        <v-list-item-action>
          <v-btn text icon color="grey darken-2" @click.stop="$emit('signOut')" data-test="signOut">
            <v-icon>exit_to_app</v-icon>
          </v-btn>
        </v-list-item-action>
      </v-list-item>
    </v-list>
    <v-divider />
    <v-list dense class="pa-0 ret-main-menu">
      <v-list-item
        v-if="$canm('pipe')"
        @click="navigate({ name: 'pipe-tasks' })"
        :class="activeClass('pipe-tasks')"
      >
        <v-list-item-avatar>
          <v-icon>av_timer</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>{{ $t('today') }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        v-if="$can('admin') && $canm('pipe')"
        @click="navigate({ name: 'projects' })"
        :class="activeClass('projects')"
      >
        <v-list-item-avatar>
          <v-icon>card_travel</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>{{ $tc('projects.entity-name', 2) }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <v-divider v-if="$can('admin') && $canm('pipe')" />
    <v-list dense class="pa-0 ret-main-menu" v-if="$canm('assets')">
      <v-list-item
          @click="navigate({ name: 'city-map' })"
          :class="activeClass('city-map')"
        data-test="navigation-city-map"
        data-tutorial="1"
      >
        <v-list-item-avatar>
          <v-icon>map</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>{{ $t('city-map') }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <v-divider />
    <v-list dense class="pa-0 ret-main-menu">
      <v-list-group
        v-if="$canm('mnt')"
        v-model="menuActive.maintenance"
        prepend-icon="build"
        data-test="navigation-maintenance"
      >
        <v-list-item slot="activator">
          <v-list-item-content>
            <v-list-item-title>{{ $t('maintenance') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          @click="navigate({ name: 'issues' })"
          :class="activeClass('issues')"
          data-test="navigation-issues"
        >
          <v-list-item-avatar>
            <v-icon>build</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>{{ $tc('issues.entity-name', 2) }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          @click="navigate({ name: 'interventions' })"
          :class="activeClass('interventions')"
          data-test="navigation-interventions"
        >
          <v-list-item-avatar>
            <v-icon>history</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>{{ $tc('interventions.entity-name', 2) }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          v-if="$can('manager')"
          @click="navigate({ name: 'planned-issue-definitions' })"
          :class="activeClass('planned-issue-definitions')"
          data-test="navigation-issue-planner"
        >
          <v-list-item-avatar>
            <v-icon>event</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>{{ $t('issues.planner') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          v-if="$can('manager')"
          @click="navigate({ name: 'issue-codes' })"
          :class="activeClass('issue-codes')"
          data-test="navigation-issue-codes"
        >
          <v-list-item-avatar>
            <v-icon>flag</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>{{ $tc('issue-codes.entity-name', 2) }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          v-if="$canm('mnt', 'useProducts') && $can('manager')"
          @click="navigate({ name: 'products' })"
          :class="activeClass('products')"
          data-test="navigation-products"
        >
          <v-list-item-avatar>
            <v-icon>developer_board</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>{{ $tc('products.entity-name', 2) }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
    </v-list>
    <v-divider />
    <v-list dense class="pa-0 ret-main-menu">
      <v-list-group
        v-if="$canm('vis')"
        v-model="menuActive.visual"
        prepend-icon="transform"
        data-test="navigation-visualization"
      >
        <v-list-item slot="activator">
          <v-list-item-content>
            <v-list-item-title>{{ $t('visualization') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          @click="navigate({ name: 'visuals' })"
          :class="activeClass('visuals')"
          data-test="navigation-visual-schemes"
        >
          <v-list-item-avatar>
            <v-icon>transform</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>{{ $tc('visuals.scheme', 2) }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          @click="navigate({ name: 'logs' })"
          :class="activeClass('logs')"
          data-test="navigation-logs"
        >
          <v-list-item-avatar>
            <v-icon>timeline</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>{{ $t('logs') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
    </v-list>
    <v-divider />
    <v-list dense class="pa-0 ret-main-menu">
      <v-list-group
        v-if="$canm('assets')"
        v-model="menuActive.assets"
        prepend-icon="devices"
        data-test="navigation-assets"
      >
        <v-list-item slot="activator">
          <v-list-item-content>
            <v-list-item-title>{{ $tc('assets.entity-name', 2) }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          @click="navigate({ name: 'assets' })"
          :class="activeClass('assets')"
          data-test="navigation-assets-list"
        >
          <v-list-item-avatar>
            <v-icon>devices</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>{{ $tc('assets.entity-name', 2) }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          v-if="$can('manager')"
          @click="navigate({ name: 'asset-types' })"
          :class="activeClass('asset-types')"
          data-test="navigation-assets-types"
        >
          <v-list-item-avatar>
            <v-icon>local_offer</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>{{ $tc('asset-types.entity-name', 2) }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          v-if="$canm('assets', 'useOwners')"
          @click="navigate({ name: 'owners' })"
          :class="activeClass('owners')"
        >
          <v-list-item-avatar>
            <v-icon>domain</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>{{ $tc('owners.entity-name', 2) }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
    </v-list>
    <v-divider />
    <v-list dense class="pa-0 ret-main-menu" v-if="$can('dispatcher') && $canm('mnt')">
      <v-list-group
        v-model="menuActive.reports"
        prepend-icon="equalizer"
        data-test="navigation-reports"
      >
        <v-list-item slot="activator">
          <v-list-item-content>
            <v-list-item-title>{{ $tc('reports.entity-name', 2) }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          @click="$router.push({name: 'reports/common-future-workload'})"
          :class="activeClass('reports/future-workload')"
          data-test="navigation-reports-futureworkload"
        >
          <v-list-item-avatar>
            <font-awesome-icon icon="briefcase"></font-awesome-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>{{ $t('future-workload') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          @click="$router.push({name: 'reports/compliance-report'})"
          :class="activeClass('reports/compliance-report')"
          data-test="navigation-reports-compliancereport"
        >
          <v-list-item-avatar>
            <font-awesome-icon icon="bug"></font-awesome-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>{{ $t('compliance-report') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          @click="$router.push({name: 'reports/issued-commands'})"
          :class="activeClass('reports/issued-commands')"
          data-test="navigation-reports-issuedcommands"
        >
          <v-list-item-avatar>
            <font-awesome-icon icon="terminal"></font-awesome-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>{{ $t('issued-commands') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          @click="$router.push({name: 'reports/device-statistics'})"
          :class="activeClass('reports/device-statistics')"
          data-test="navigation-reports-devicestatistics"
        >
          <v-list-item-avatar>
            <font-awesome-icon icon="chart-area"></font-awesome-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>{{ $t('device-statistics') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          v-if="$cans('prg')"
          @click="$router.push({name: 'reports/prg'})"
          :class="activeClass('reports/prg')"
          data-test="navigation-reports-prg"
        >
          <v-list-item-avatar>
            <font-awesome-icon icon="people-carry"></font-awesome-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>Přehled práce</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
    </v-list>
    <v-divider />
    <v-list dense class="pa-0 ret-main-menu">
      <v-list-group
        v-model="menuActive.settings"
        prepend-icon="settings"
        data-test="navigation-settings"
      >
        <v-list-item slot="activator">
          <v-list-item-content>
            <v-list-item-title>{{ $t('settings') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          v-if="$canm('mnt')"
          @click="navigate({ name: 'teams/id', params: { id: currentTeamId } })"
          :class="activeClass('teams/id')"
          data-test="navigation-team"
        >
          <v-list-item-avatar>
            <v-icon>people_outline</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>{{ $t('team') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          v-if="$canm('mnt', 'useChecklists') && $can('manager')"
          @click="navigate({ name: 'checklists' })"
          :class="activeClass('checklists')"
          data-test="navigation-checklists"
        >
          <v-list-item-avatar>
            <v-icon>playlist_add_check</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>{{ $tc('checklists.entity-name', 2) }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          @click="navigate({ name: 'user-settings' })"
          :class="activeClass('user-settings')"
          data-test="navigation-my-settings"
        >
          <v-list-item-avatar>
            <v-icon>settings</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>{{ $t('my-settings') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          v-if="$can('manager')"
          @click="navigate({ name: 'users' })"
          :class="activeClass('users')"
          data-test="navigation-users"
        >
          <v-list-item-avatar>
            <v-icon>people</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>{{ $tc('users.entity-name', 2) }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          v-if="$can('admin')"
          @click="navigate({ name: 'imports' })"
          :class="activeClass('imports')"
          data-test="navigation-data-import"
        >
          <v-list-item-avatar>
            <v-icon>import_export</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>{{ $t('data-imports') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
    </v-list>
    <template v-slot:append>
      <div v-if="$can('admin')" class="caption">
        fe: <a target="_blank" href="https://gitlab.com/revitest/observer-ui/blob/develop/CHANGELOG.md">{{ feVersion }}</a> |
        be: <a target="_blank" href="https://gitlab.com/revitest/observer-be/blob/develop/CHANGELOG.md">{{ beVersion }}</a>
      </div>
    </template>
  </v-navigation-drawer>
</template>

<style scoped lang="scss">
/* makes all menu items same height */
.ret-main-menu-nav-desktop .v-list-item__action,
.ret-main-menu-nav-desktop .v-list-item__avatar {
  margin-top: 0;
  margin-bottom: 0;
}
/* active menu item highlight */
.active-link {
  background-color: #deecfc;
}

.svg-inline--fa {
  opacity: 0.7;
}
</style>

<script>
export default {
  name: 'main-menu',
  props: ['currentTeamId', 'showMenuProp'],
  data () {
    return {
      dataLoaded: false,
      menuActive: {
        pipe: true,
        maintenance: true,
        visual: true,
        assets: true,
        reports: false,
        settings: false
      }
    }
  },
  computed: {
    feVersion () {
      return this.$store.state.feVersion
    },

    beVersion () {
      return this.$store.state.site.beVersion
    },
    currentUser () {
      return this.$store.state.auth.currentUser
    },
    isDesktop () {
      return this.$store.state.userAgent.isDesktop
    },
    isMobile () {
      return this.$store.state.userAgent.isMobile
    },
    showMenu: {
      get () {
        return this.showMenuProp
      },
      set (val) {
        this.$emit('showMenuChanged', val)
      }
    }
  },
  methods: {
    navigate (route) {
      const { name } = route
      if (this.$route.name !== name) {
        // avoid NavigationDuplicated error
        this.$router.push(route)
      }
    },
    activeClass (...args) {
      const [ name, ...rest ] = args
      const regex = new RegExp(`^${name}`)
      return rest.concat([regex.test(this.$route.name) ? 'active-link' : ''])
    }
  }
}
</script>
